export default "__VITE_ASSET__61549539__"